import { Typography } from '@mui/material';
import { FC } from 'react';
import { useSelector } from 'react-redux';

import { portalTypeSelector } from '../../../../app/selectors/portal-type.selector';
import { otpLegalDocumentSelector } from '../../selectors/legal-document-selectors';
import { DocumentLinks } from '../document-links';

const DocumentConsentNotice: FC = () => {
  const documents = useSelector(otpLegalDocumentSelector);
  const portalType = useSelector(portalTypeSelector);

  const nextButtonText = portalType === 'verify' ? '"Call me" or "Text me"' : '"Next"';
  const consentText =
    ", which includes consent to electronic signatures and communications, and I agree Coast may contact me at the number I've provided about its products and services.";

  return (
    <Typography variant="caption" align="center" component="div">
      By clicking on the {nextButtonText} button, I agree to the Coast
      <DocumentLinks documents={documents} />
      {consentText}
    </Typography>
  );
};

export { DocumentConsentNotice };
